var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v(" Hello "+_vm._s(_vm.user.firstName)+"! ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }